/* @flow weak */
import * as React from 'react';

import BirthdateModalSection from 'chat/components/BirthdateModalSection';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import RoleSelector from './RoleSelector';
import UserActions from 'user/UserActions';

class AskForRole extends React.Component<{}, *> {
  state = {
    role: '',
  };

  onSubmit = () => {
    UserActions.setRole(this.state.role);
  };

  buttonDisabled = () => {
    return false;
  };

  roleChanged = role => {
    this.setState({ role });
  };

  renderCollector = () => {
    return <RoleSelector onChange={this.roleChanged} value={this.state.role} />;
  };

  render() {
    return (
      <BirthdateModalSection
        title="To use Chat, please let us know your role."
        subtext={<Link href={LinkConstants.CHAT_RESTRICTIONS}>Learn more</Link>}
        renderCollector={this.renderCollector}
        buttonDisabled={this.buttonDisabled}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default AskForRole;
